import {
  acceptGuardianInvitation,
  declineGuardianInvitation,
  fetchGuardianInvitation,
} from '@/features/guardian/services/guardian-invitations';
import { guardianKeys } from '@/features/guardian/queries/query-keys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const invitationKey = (token: string) => ['guardian-invitation', token] as const;

export function useGuardianInvitationQuery(
  token: string,
  enabled: boolean,
  hasAuthenticatedSession: boolean,
) {
  return useQuery({
    queryKey: [...invitationKey(token), hasAuthenticatedSession ? 'authenticated' : 'anonymous'],
    queryFn: () => fetchGuardianInvitation(token, !hasAuthenticatedSession),
    enabled: enabled && token.length > 0,
    retry: false,
  });
}

export function useAcceptGuardianInvitationMutation(token: string, guardianId?: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => acceptGuardianInvitation(token),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: guardianKeys.players(guardianId),
        }),
        queryClient.invalidateQueries({
          queryKey: guardianKeys.profile(guardianId),
        }),
        queryClient.invalidateQueries({
          queryKey: invitationKey(token),
          refetchType: 'none',
        }),
      ]),
  });
}

export function useDeclineGuardianInvitationMutation(token: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => declineGuardianInvitation(token),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: invitationKey(token),
        refetchType: 'none',
      }),
  });
}
